var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHypohygenic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.084,
    height: 93.299,
    viewBox: "0 0 64.084 93.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1cd99c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04a9e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hypoallergenic",
    transform: "translate(2.5 4.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M202.672,147.911a28.971,28.971,0,0,1-57.94,0c0-21.37,28.97-58,28.97-58S202.672,126.541,202.672,147.911Z",
    transform: "translate(-144.732 -89.91)",
    fill: "none",
    stroke: "#1dd99e",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M214.59,209.4a4.362,4.362,0,0,1-3.455-1.7l-10.107-13.115c-3.362-4.362,3.511-9.736,6.911-5.326l6.325,8.207,24.9-38.815c2.936-4.578,10.431-.1,7.343,4.711L218.262,207.39a4.711,4.711,0,0,1-3.672,2.007Z",
    transform: "translate(-185.657 -139.282)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHypohygenic);
export default __webpack_public_path__ + "static/media/hypohygenic.acded59d94369e53be610a4d3940c9a8.svg";
export { ForwardRef as ReactComponent };